require('./video-items/video-items.scss');
var VideoItem = require('./video-item');
var VideoItems = Marionette.CollectionView.extend({
    className: 'fmcy-video-items row-flex clearfix',
    childView: VideoItem,
    childEvents: {
        'thumb:clicked': 'onChildThumbClicked'
    },
    onChildThumbClicked: function(childView) {
        this.trigger('thumb:clicked', childView.model, this.options.collection);
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                thumbStyle: 'thumbs'
            }
        );
    },
    childViewOptions: function(model, index) {
        var extraClassName = 'col-flex-xs-12';
        var videoStyle = 'thumb';
        if (index === 0 && this.options.collection.length !== 2) {
            videoStyle = 'feature';
        }
        if (videoStyle === 'thumb') {
            extraClassName += ' col-flex-sm-6';
        }
        if (this.options.collection.length === 4 && videoStyle !== 'feature') {
          extraClassName += ' col-flex-md-4';
        }

        return {
            collection: this.options.collection,
            extraClassName: extraClassName,
            videoStyle: videoStyle
        };
    },
    onRender: function() {
        this.$el.addClass(this.options.thumbStyle);
    }
});
module.exports = VideoItems;



/** WEBPACK FOOTER **
 ** ./assets/js/common/video-group/video-items.js
 **/